import React, { useEffect, useState } from 'react';
import * as Sentry from '@sentry/browser';
import './css/vars.css';
import './App.css';
import "./yoello-lib/modules/ui-kit/index.scss";
import AppRouter from './components/router/Router';
import Modal from './components/modal/Modal';
import { CircularProgress, Snackbar } from '@material-ui/core';
import { DialogComponent } from './components/modal/DialogHandleComponent';
import { ThemeCreator } from './yoello-lib/modules/themes/ThemeCreator';
import FlagsProvider from './providers/FlagsProvider';
import { useVenueDataLayer } from './hooks/useVenueDataLayer';
import { Alert } from '@material-ui/lab';
import { useSelector } from 'react-redux';
import { IReduxAppState } from './reducers';

const hiretext = require(`./misc/hire.json`);
const packageJSON = require('../package.json');

const hostMap: { [hostname: string]: string; } =
{
  "localhost": "local",
  "dev-partners-lrk0i9.yoello.com": "dev",
  "staging-partners-89e5si.yoello.com": "staging",
  "partners.yoello.com": "prod"
};

// Sentry will monitor our app and report any issues
if (hostMap[window.location.hostname] !== "local") {
  Sentry.init({
    dsn: "https://9866812a71de42dba5032d53fecf0389@o329619.ingest.sentry.io/5244417",
    environment: hostMap[window.location.hostname],
    release: `merchant-dashboard@${packageJSON.version}`
  });
}

console.log(`%c ${hiretext}`, 'background: #222; color: #bada55');

export const SHOW_BANNER_VENUES = ["YOELLO", "RMS"];
export const NOT_INCLUDED_VENUES = [
  "9e8a0a80-590e-4875-94c0-8ae7b3425351",
  "2b83c71d-7f0b-4f16-8b6f-6a715e1e53dc",
  "2d614b0c-6ebe-41a7-ae44-bbfe4235518b",
  "6aa5cee9-be45-4cb3-9c9c-1937d18bc65e",
  "2092f1b2-a07e-4abb-852a-6eb5e8f93642",
  "1a51130b-4cae-4466-819a-70d5db16d358",
  "4c7d55a4-77a0-414f-be33-79422ecc5267",// Poorya3 venue for testing on dev
]
function App() {
  const [showSnackbar, setShowSnackbar] = useState(false)
  const venueID = useSelector((state: IReduxAppState) => state.selectedVenueId);
  const Venue = useSelector(
    (state: IReduxAppState) => state.venue[venueID]?.venueData
  );
  useEffect(() => {
    if(Venue){
      if(NOT_INCLUDED_VENUES.includes(Venue.id as string)){
        return;
      }
      const showBanner = SHOW_BANNER_VENUES.includes(Venue?.onboarding_source as unknown as string); 
      setShowSnackbar(showBanner)
    }
    }, [Venue])
  useVenueDataLayer();
  /**Disables mobile devices */
  return <ThemeCreator LoadingComponent={<CircularProgress />}>
    <DialogComponent />
    <FlagsProvider>
      <AppRouter />
    </FlagsProvider>
    <Modal />
    <Snackbar
            open={showSnackbar}
            onClose={()=>setShowSnackbar(false)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert onClose={()=>setShowSnackbar(false)} severity={'error'}>
                <p style={{
                  fontSize:"1rem",
                  margin:"0"
                }}>
                      <strong>IMPORTANT ANNOUNCEMENT REGARDING OUR SERVICES <br/> 17 November 2023</strong><br/>
                      Yoello has decided to withdraw its mobile order and pay solutions from the hospitality market. We are therefore terminating the Merchant Agreement between us and serving you with 30 days’ notice in accordance with Clause 10.2 of the Yoello Merchant Terms of Use Agreement (“Agreement”).   Termination of the Agreement will therefore take effect at midnight on 17 December 2023, which is 30 days from the date of this notice.  
                      Further information can be found <a href='https://www.yoello.com/announcement-2023'>here</a>.
                </p>
            </Alert>
        </Snackbar>
  </ThemeCreator>;
}

export default App;
